import { render, staticRenderFns } from "./TopHeaderImg.vue?vue&type=template&id=0f846714&scoped=true"
import script from "./TopHeaderImg.vue?vue&type=script&lang=ts"
export * from "./TopHeaderImg.vue?vue&type=script&lang=ts"
import style0 from "./TopHeaderImg.vue?vue&type=style&index=0&id=0f846714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f846714",
  null
  
)

export default component.exports